import { useEffect } from "react";
import { Container } from "layouts";
import { Link, useLocation } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import HomeHero from "./HomeHero";
import FeaturedBooks from "./FeaturedBooks";
import ReadingGuide from "./ReadingGuide";
import ReadingOptions from "./ReadingOptions";
import HomeFaq from "./HomeFaq";
import HomeFooter from "./HomeFooter";
import "./home.css";

const Home = () => {
	const { hash } = useLocation();
	useEffect(() => {
		if (!hash) return undefined;
		// Let the shared header's measured height reach the section scroll margins.
		const frame = requestAnimationFrame(() => document.getElementById(hash.slice(1))?.scrollIntoView({ block: "start" }));
		return () => cancelAnimationFrame(frame);
	}, [hash]);

	useEffect(() => {
		document.documentElement.classList.add("home-smooth-scroll");
		return () => document.documentElement.classList.remove("home-smooth-scroll");
	}, []);

	return (
	<Container
		className="home-page"
		footer={<HomeFooter />}
		skipLink={<a className="home-skip-link" href="#home-main">Skip to content</a>}
	>
		<main id="home-main" tabIndex={-1}>
			<HomeHero />
			<FeaturedBooks />
			<ReadingGuide />
			<ReadingOptions />
			<HomeFaq />
			<section className="home-closing" aria-labelledby="closing-heading">
				<div className="home-wrap home-closing-inner">
					<div><p className="home-eyebrow">THERE’S MORE BETWEEN THE PAGES</p><h2 id="closing-heading">Find your next great read.</h2><p>A new skill, a new perspective, or a story you won’t want to put down.</p></div>
					<Link to="/books" className="home-button home-button-light">Browse books <FiArrowRight aria-hidden="true" /></Link>
				</div>
			</section>
		</main>
	</Container>
	);
};
export default Home;
